import { faBook, faGraduationCap, faBusinessTime,faCannabis} from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import MySelfCart from './MySelfCart';
import { Slide } from 'react-reveal';

const myData = [
    {
        logo: faBook,
        title: 'ক্লাস ১-১২',
        customPathLocation: 'class1to12'
    },
    {
        logo: faGraduationCap,
        title: 'ভর্তি পরীক্ষা',
        customPathLocation: 'admission'
    },
    {
        logo: faBusinessTime,
        title: 'চাকরি প্রস্তুতি',
        customPathLocation: 'jobPreperation'
    },
    {
        logo: faCannabis,
        title: 'স্কিলস',
        customPathLocation: 'skills'
    },
]

const MySelf = () => {
    return (
        <div className='container'>
            <div className="my-title text-center mt-5 mb-5">
                <div className="myself">
                    <Slide left>
                        <h3 className='fw-bold fs-2'>নিজের শেখা নিজেই গুছিয়ে <br /> নেয়ার যাত্রা শুরু হোক</h3>
                        <p className='fs-4'>যেকোনো বিষয়ের যেকোনো টপিকে পড়ালেখা করতে চলে যাও তোমার পছন্দের সেকশনে</p>
                    </Slide>
                </div>
                <div className="mydata mt-5 mb-5">
                    <div className="row gy-3">
                        {
                            myData.map(pd => <MySelfCart pd={pd} key={pd.title} />)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MySelf;